import { render, staticRenderFns } from "./TemperatureHumidity.vue?vue&type=template&id=96c1be7e&scoped=true&"
import script from "./TemperatureHumidity.vue?vue&type=script&lang=js&"
export * from "./TemperatureHumidity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c1be7e",
  null
  
)

export default component.exports